import React from 'react';
import Cookies from 'js-cookie';
import styled from "styled-components";

import { useState, useEffect } from "react";

import { TwModal } from '@ui-component-library';
import { ErrorModal } from '../../../modals';

import { getPropStatus, fetchPropertyData, getProp, deleteProperty } from '../../../api/services/property';
import { useVisaValdaStore } from '../store/VisaValdaStore';
import { usePropsDataStore } from '../store/PropsDataStore';
import { useUpdateProperty } from '../hooks/useUpdateProperty';
import { usePropertyRegeneration } from '../hooks/usePropertyRegeneration';




const CustomScrollbar = styled.div`
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-thumb {
        background: #023436;
        border-radius: 10px;
    }
`

const SettingsPanel = ({ visible,property, setVisibility}) => {
    
    const setVisaValda = useVisaValdaStore((state) => state.setVisaValda);
    const { props, setProps, setOneProp } = usePropsDataStore();
    const { updatePropertySections } = useUpdateProperty();
    const { regenerateProperty: regeneratePropertyHook, loading: loadingReset } = usePropertyRegeneration();
    const [loading, setLoading] = useState(false)
    const [startPanelShow, setStartPanelShow] = useState(false)
    const [settingsSectionShow, setSettingsSectionShow] = useState(false)

    const [updateDate, setUpdateDate] = useState(null)
    const [selectedProperty, setSelectedProperty] = useState(property)
    const [collapsed, setCollapsed] = useState(false);

    // Modals
    const [infoModal, setInfoModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const imageBaseUrl  = `${Window.static_path}img/icons`

    useEffect(() => {
        if (property){
            setSelectedProperty(property)
            if (Window.react_data?.updated_props_dates){
                const prop = Window.react_data.updated_props_dates.find(item => item.ref === property.ref);
                setUpdateDate({ref:property.ref,date:prop?prop.date:""})
            }
           }
        }, [property]);

    useEffect(() => {
        if (visible){
            setStartPanelShow(true)
        }
    }, [visible]);



    // REST API
    
    const removePropertyFromCookie=(ref)=>{

        let activePropsCookie = Cookies.get('activeProps')
        if(activePropsCookie){
            let propList = activePropsCookie.split(',').filter(prop => prop != ref)
            Cookies.set('activeProps', propList.map(p => p).join(','))
        }

    }

    const fetchPropData = async (p) => {
        const response = await fetchPropertyData(p.ref, p.type)
        const data = response.data
        
        let updatedProp = { ...p };
        if(data && typeof data == 'object') {
            updatedProp.data = data;
        } else {
            updatedProp.status = 'warning';
        }

        if(data) {
            if(p.type == 'PROP') {
                const response = await getProp(p.ref)
                const propData = response.data

                if(propData) {
                    updatedProp.border = propData.geojson.geometry.coordinates
                    updatedProp.area = propData.area                    
                }
            }
            
            updatedProp.loading = false
            setLoadingReset(false)
            setLoading(false)
        }
        
        setOneProp(updatedProp)
        }

    const checkPropStatus = async (property) => {
        const response = await getPropStatus(property.ref)
        const status = response.data
        
        if(status == 'broken' || status == 'data') { 
            const updatedProperty = { ...property, status: status };
            setOneProp(updatedProperty)
            if(status == 'data') {
                fetchPropData(updatedProperty)
            }
        } else {
            setTimeout(() => {
                checkPropStatus(property); 
            }, 2000);
        }
        }


    const updateProperty = async (selectedProperty) => {
        const sections = selectedProperty?.data?.sections || []

        setLoading(true)
        const { data, error } = await updatePropertySections(sections)
        if (error) {
            setErrorModal(true)
            setLoading(false)
            return
        }

        const updatedProps = props.map(p => {
            const update = data.find(i => i.ref === p.ref);
            if (update) {
                setUpdateDate({ref:update.ref, date:new Date(update.updated_date).toISOString().split("T")[0]});
                return { ...p, data: update.new_data };
            }
            return p;
        });
        setProps(updatedProps)
        setLoading(false)
    }

    // Settings panel views
    const startPanel = () => {
        return <div>
            <div className='flex justify-between'>
                <p className='fs-7 mb-0'>Inställningar</p>
                <p className='fs-7 mb-0' style={{ cursor: "pointer" }} onClick={() => {setStartPanelShow(false); setSettingsSectionShow(false); setVisibility() }}>Stäng</p>
            </div>
            <hr className='my-6' style={{ borderColor: "#D7D8DA" }}></hr>
            <div className='rounded-2xl p-6 bg-white flex justify-between items-center'>
                <div><p className='fs-7 mb-1'>Fastighet</p>
                <p className='fs-7 neutral-charcoal-300 mb-0'>{selectedProperty.designation}</p></div>
                <div role='button' onClick={() => setCollapsed(!collapsed)} ><div className={`${collapsed ? 'rotate-50' : ''}`} style={{transition: 'transform .2s ease-in-out'}}><img src={`${Window.static_path}img/icons/dropdown-arrow.svg`} style={{ width: "16px", height: "16px" }}/></div></div>
            </div>
            <hr className='my-6' style={{ borderColor: "#D7D8DA" }}></hr>      
            {!collapsed && <> <div className='rounded-2xl p-6 bg-white flex justify-between' role='button' onClick={()=>{setStartPanelShow(false);setSettingsSectionShow(true)}}>
                <div className='flex justify-start'><img src={`${Window.static_path}img/icons/refresh.svg`} style={{ width: "20px", height: "20px" }}/><p className='fs-7 mb-0 ml-4'>Uppdatera eller återställ</p></div>
                <img src={`${imageBaseUrl}/caret.svg`} style={{ width: "20px", height: "20px" }}/>
            </div>
            <div className='rounded-2xl p-6 mt-6 bg-white flex justify-start' role='button' onClick={() => {setDeleteModal(selectedProperty)}}>
                <p className='mb-0'><img src={`${imageBaseUrl}/trash.svg`} className='supp-redwood-filter mr-4' style={{ width: "20px", height: "20px" }}/><span className='fs-7 supp-redwood-500'>Radera fastigheten</span></p>
            </div>
            {selectedProperty.dfr ? <div className='rounded-2xl p-6 mt-6 bg-white flex justify-between' role='button' onClick={()=>{window.open(`${window.location.origin}/map-api/sbp-to-pdf/?ref=${selectedProperty.ref}`, '_blank');}}>
                <div className='flex justify-start items-center'><img src={`${Window.static_path}img/icon-files/pdf.svg`} style={{ width: "20px", height: "20px" }}/><p className='fs-7 mb-0 ml-4'>Exportera PDF</p></div>
                <img src={`${imageBaseUrl}/caret.svg`} style={{ width: "20px", height: "20px" }}/>
            </div> : null}
            </>}
        </div>
    }
    
    const settingsPanel=()=>{

       const updateSbp=()=>{
            if (loading== false){
                updateProperty(selectedProperty)
            }
            }

        const reset = () => {
            if (loadingReset == false) {
                regeneratePropertyHook(selectedProperty, (selectedProp, json) => {
                    setStartPanelShow(false)
                    setSettingsSectionShow(false)
                    setVisibility()
                    setUpdateDate({ ref: selectedProp.ref, date: new Date(json.date).toISOString().split("T")[0] })
                }).then((result) => {
                    if (!result?.error) {
                        return
                    }

                    if (result.error == "Could not find property/user combination or regenerated to soon.") {
                        setInfoModal({
                            title: "Kunde inte återskapa fastighet", message: <>Det gick inte att återskapa fastigheten. Vänta en stund och försök igen.
                                Om problemet kvarstår.Kontakta oss på <a className='font-bold' href='mailto:information@treebula.se'>information@treebula.se</a> eller <a className='font-bold' href='tel:00468339944'>08-33 99 44</a> så hjälper våra rådgivare dig att lösa detta så snabbt som möjligt.</>
                        })
                        return
                    } else if (result.error == "Property is deprecated") {
                        setInfoModal({
                            title: "Kunde inte återskapa fastighet", message: <> Du har valt en gammal skogsbruksplan som inte går att återskapa. Du har en ny version av denna skogsbruksplan att välja istället som går att återskapa.</>
                        })
                    }
                    setErrorModal(true)
                })
            }
        }
        const updatedDate = updateDate?.ref === selectedProperty.ref ? updateDate.date : "";
       

        const settingOptions = [
            {icon:`${imageBaseUrl}/sync.svg`,title:"Uppdatera",updateDate:`Senast uppdaterad: ${updatedDate}`,updateText:"Uppdaterar och ändrar endast data i avgränsningar till den senaste versionen."},
            {icon:`${imageBaseUrl}/update.svg`,title:"Återställ & regenerera",updateText:"Återställer fastigheten och raderar alla ändringar."}]
        return <div>
            <div className='flex justify-between'>
                <p className='fs-7 mb-0' style={{ cursor: "pointer" }} onClick={() => { setStartPanelShow(true); setSettingsSectionShow(false) }}>Tillbaka</p>
                <p className='fs-7 mb-0'>Uppdatera eller återställ</p>
                <p className='fs-7 mb-0' style={{ cursor: "pointer" }} onClick={() => { setStartPanelShow(false); setSettingsSectionShow(false);setVisibility() }}>Stäng</p>
            </div>
            <hr className='my-6' style={{ borderColor: "#D7D8DA" }}></hr>
            <div className='rounded-2xl p-6 mt-6 bg-white flex justify-between items-center'>
                <div><p className='fs-7 mb-1'>Fastighet</p>
                <p className='fs-7 mb-0 neutral-charcoal-300'>{selectedProperty.designation}</p></div>
                <div role='button' onClick={() => setCollapsed(!collapsed)} ><div className={`${collapsed ? 'rotate-50' : ''}`} style={{transition: 'transform .2s ease-in-out'}}><img src={`${Window.static_path}img/icons/dropdown-arrow.svg`} style={{ width: "16px", height: "16px" }}/></div></div>
            </div>
            <hr className='mt-6 mb-0' style={{ borderColor: "#D7D8DA" }}></hr>
            <CustomScrollbar>
                {!collapsed && settingOptions.map((setting, index) => (
                    <div key={index} className='rounded-2xl p-6 mt-6 bg-white'>
                        <div className='flex flex-row items-start'> <img className='mr-2' src={setting.icon} style={{ width: "20px", height: "20px" }} /><div><div className='flex justify-between'><div>
                            <p className='fs-7 mb-0'>{setting.title}<br />{setting?.updateDate ? <span className='fs-8 neutral-charcoal-300'>{setting.updateDate}</span> : null}</p></div>
                            {setting.title !== "Återställ & regenerera" ? <p className={`fs-7 bg-neutral-stone-100 py-1 px-2 rounded-lg ${loading === false ? "" : "disabled-grey"}`} style={{ cursor: "pointer" }} onClick={() => { updateSbp() }} >{loading === false ? "Uppdatera" : "Uppdaterar"}</p> : <p className='fs-7 bg-neutral-stone-100 py-1 px-2 rounded-lg danger-700 mb-0' style={{ cursor: "pointer" }} onClick={() => { reset() }}>{loadingReset === false ? "Återställ" : "Återställer.."}</p>}  </div>
                            <hr className='my-2' style={{ borderColor: "#F5F5F5" }}></hr>
                            <p className='mt-2 fs-7'>{setting.updateText}</p></div></div>
                    </div>))}
            </CustomScrollbar>
        </div>
    
    }

   


    return (<div>
        {visible && (
            <div className='fixed inset-y-0 left-0 z-[1045] flex sm:w-[322px] w-full max-h-full sm:max-h-none overflow-y-auto bg-[#F6F7F8] transition-transform duration-300 p-6 rounded-t sm:rounded-none shadow-lg'>
                {startPanelShow && startPanel()}
                {settingsSectionShow && settingsPanel()}
            </div>
        )}

        <TwModal isOpen={!!infoModal} className="bg-neutral-cloud p-2">
            {infoModal.title && <TwModal.Header>
                <div className="flex justify-between items-start">
                    <h2 className="neutral-charcoal mb-0 n-h4">{infoModal.title}</h2>
                    <button type="button" className="ml-auto fs-5 leading-none" onClick={() => setInfoModal(false)} aria-label="Close">&times;</button>
                </div>
            </TwModal.Header>}
            {infoModal.message && <TwModal.Content>
                <p className='neutral-charcoal'>{infoModal.message}</p>
            </TwModal.Content>}
            <TwModal.Footer>
                <div className="flex justify-end">
                    <button type="button" className="n-btn btn-forest-green" onClick={() => setInfoModal(false)}>Stäng</button>
                </div>
            </TwModal.Footer>
        </TwModal>

        <TwModal isOpen={!!deleteModal} className="bg-neutral-cloud-200 p-2">
            <TwModal.Header>
                <div className="flex justify-between items-start">
                    <h4 className="mb-0">Radera fastighet</h4>
                    <button type="button" className="ml-auto fs-5 leading-none" onClick={() => setDeleteModal(false)} aria-label="Close">&times;</button>
                </div>
            </TwModal.Header>
            <TwModal.Content>
                <p className='fs-5 neutral-charcoal mb-0'>Är du säker på att du vill radera {deleteModal.designation}?</p>
            </TwModal.Content>
            <TwModal.Footer>
                <div className="flex justify-between">
                    <button type="button" className="n-btn btn-forest-green" onClick={() => setDeleteModal(false)}>Avbryt</button>
                    <button type="button" className="n-btn btn-core" onClick={async () => {
                        let prop = deleteModal
                        setOneProp({ ...prop, loading: true })
                        setDeleteModal(false)
                        setVisibility()

                        const deletePropResp = await deleteProperty(prop.ref, prop.type)
                        if(deletePropResp.ok) {
                            removePropertyFromCookie(prop.ref)

                            const updatedProps = props.filter(p => p.ref != prop.ref)
                            setProps(updatedProps)

                            if (prop.active) {
                                setVisaValda(true)
                            }
                        }
                    }}>Radera</button>
                </div>
            </TwModal.Footer>
        </TwModal>

        {/* ERROR Modal */}
        <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
    </div>
    );
};

export default SettingsPanel;
